let doctor = [
  {
    path: '/doctor_index',
    name: '医生主页',
    component: () => import('@/pages/doctor/doctor_index')
  },
  {
    path: '/doctor_index_registration',
    name: '挂号主页',
    component: () => import('@/pages/doctor/doctor_index_registration')
  },
  {
    path: '/doctor_index_registration_new',
    name: '挂号主页',
    component: () => import('@/pages/doctor/doctor_index_registration_new')
  },
  {
    path: '/doctor_index_new',
    name: '新医生主页',
    component: () => import('@/pages/doctor/doctor_index_new')
  }
]

export default doctor
